// What the floating + opens: the speed-dial of frame v2.12.
//
// The frame (template L695-705, `fabItems` in its script) draws the + as a
// 60px ink disc floating at the bottom-right of a phone, above the tab bar,
// and tapping it fans four labelled pills up from it over a scrim:
//
//   Safety          white on ink    — the WHS report, raises nothing
//   Quality alert   warn            — a defect on this pod, to Quality
//   Andon           danger          — I need someone now
//   Scan pod        ink             — nearest the +, because a scan starts
//                                     every pod and is the one used a hundred
//                                     times a day; the thumb reaches it first
//
// Top to bottom in that order, which is bottom-up by frequency: the pill a
// thumb lands on first after opening the dial is Scan, then the two raise
// kinds, then Safety at the top where the once-a-month thing can afford to be.
//
// Pure, so the order and the tones can be tested without rendering. There is
// no muting rule here any more: the + is hidden on the job screen altogether
// (frame `showPlusFab`), so a scan can never be offered mid-pod.

import type { IconName } from '@/components/ui/Icon';
import type { StringKey } from '@/i18n/strings';

export type FabItemKey = 'safety' | 'quality' | 'andon' | 'scan';

export interface FabItem {
  key: FabItemKey;
  icon: IconName;
  label: StringKey;
  /** The pill's icon tile: the frame's `bg`/`color` pair per item. */
  tone: 'neutral' | 'warn' | 'danger' | 'ink';
}

/** The pills, top to bottom as the frame stacks them. */
export function fabItems(): FabItem[] {
  return [
    { key: 'safety', icon: 'shield', label: 'fabSafetyT', tone: 'neutral' },
    { key: 'quality', icon: 'checkCircle', label: 'fabQualityAlertT', tone: 'warn' },
    { key: 'andon', icon: 'hazard', label: 'fabAndonT', tone: 'danger' },
    { key: 'scan', icon: 'barcode', label: 'fabScanPodT', tone: 'ink' },
  ];
}

/**
 * Whether the + is on screen at all.
 *
 * Phones only — a tablet has Scan in its header and Raise at the foot of its
 * rail. Never on the job screen, where a stray scan would yank the operator
 * off the pod in hand, and never while a sheet is open, where a disc floating
 * over the scrim would be a control for a screen that is not showing. The
 * frame: `isPhone && s.screen !== 'job' && !s.sheet`.
 */
export function showFab(input: { tablet: boolean; onJob: boolean; sheetOpen: boolean }): boolean {
  return !input.tablet && !input.onJob && !input.sheetOpen;
}
